import { Button } from '@/components/ui/button';
import { Select } from '@/components/ui/select';
import type { UserReference } from '@/features/leads/types';

interface JobFiltersProps {
  onFilterChange: (filter: FilterType) => void;
  onAssignedToChange: (userId: number | undefined) => void;
  currentFilter: FilterType;
  users: UserReference[];
  selectedAssignedToId?: number;
}

export type FilterType = 'all-active' | 'closed' | 'collections' | 'all' | 'by-estimator';

export function JobFilters({
  onFilterChange,
  onAssignedToChange,
  currentFilter,
  users,
  selectedAssignedToId,
}: JobFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button
        onClick={() => onFilterChange('all-active')}
        className={
          currentFilter === 'all-active'
            ? 'bg-[#0A0A9E] text-white hover:bg-[#0A0A9E]/90 rounded-[50px] px-6'
            : 'bg-[#dedede] text-[#1B1B1B] hover:bg-[#d0d0d0] rounded-[50px] px-6'
        }
      >
        All Active
      </Button>

      <Button
        onClick={() => onFilterChange('closed')}
        className={
          currentFilter === 'closed'
            ? 'bg-[#0A0A9E] text-white hover:bg-[#0A0A9E]/90 rounded-[50px] px-6'
            : 'bg-[#dedede] text-[#1B1B1B] hover:bg-[#d0d0d0] rounded-[50px] px-6'
        }
      >
        Closed
      </Button>

      <Button
        onClick={() => onFilterChange('collections')}
        className={
          currentFilter === 'collections'
            ? 'bg-[#0A0A9E] text-white hover:bg-[#0A0A9E]/90 rounded-[50px] px-6'
            : 'bg-[#dedede] text-[#1B1B1B] hover:bg-[#d0d0d0] rounded-[50px] px-6'
        }
      >
        Collections
      </Button>

      <Button
        onClick={() => onFilterChange('all')}
        className={
          currentFilter === 'all'
            ? 'bg-[#0A0A9E] text-white hover:bg-[#0A0A9E]/90 rounded-[50px] px-6'
            : 'bg-[#dedede] text-[#1B1B1B] hover:bg-[#d0d0d0] rounded-[50px] px-6'
        }
      >
        All
      </Button>

      <Button
        onClick={() => onFilterChange('by-estimator')}
        className={
          currentFilter === 'by-estimator'
            ? 'bg-[#0A0A9E] text-white hover:bg-[#0A0A9E]/90 rounded-[50px] px-6'
            : 'bg-[#dedede] text-[#1B1B1B] hover:bg-[#d0d0d0] rounded-[50px] px-6'
        }
      >
        By Estimator
      </Button>

      {currentFilter === 'by-estimator' && (
        <Select
          value={selectedAssignedToId?.toString() || ''}
          onChange={(e) => {
            onAssignedToChange(e.target.value ? Number(e.target.value) : undefined);
          }}
          className="w-48 rounded-[20px]"
        >
          <option value="">Select Estimator</option>
          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </Select>
      )}
    </div>
  );
}
